import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';

const ShowMoreTile = ({ link, goTo, label }) => (
  <div className='show-more-tile' onClick={() => goTo(link)}>
    <div className='flex-center'>
      <Link to={link}>{label}</Link>
    </div>
  </div>
)

const mapStateToProps = (state) => ({})
const mapDispatchToProps = (dispatch) => ({
  goTo: bindActionCreators(push, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(ShowMoreTile)



// WEBPACK FOOTER //
// ./src/containers/pages/app/partials/show-more-tile.js